<template>
  <div>
    <div class="case_wrap">
      <el-container>
        <el-aside width="220px">
          <el-menu :default-active="activeMenu" router>
            <router-link
              :to="{ name: 'mainPaseCmdcenter', params: { token: token } }"
              class="b_index"
            >返回首页</router-link>
            <div class="nav_box">
              <a class="nav-group">功能</a>
              <router-link
                class="ha"
                :class="{ active: activeMenu === 'add' }"
                :to="{ name: 'add', params: { token: token } }"
              >新增保险合作客户</router-link>
              <router-link
                class="ha"
                :class="{ active: activeMenu === 'pact' }"
                :to="{ name: 'pact', params: { token: token } }"
              >保险公司合同管理</router-link>
              <router-link
                class="ha"
                :class="{ active: activeMenu === 'serve' }"
                :to="{ name: 'serve', params: { token: token } }"
              >设置服务流程</router-link>
            </div>
          </el-menu>
        </el-aside>
        <el-main>
          <router-view></router-view>
        </el-main>
      </el-container>
    </div>
  </div>
</template>

<script>
/**
 * 保险公司合同相关功能布局页
 */
export default {
  data() {
    return {
      token:
        this.$route.params.token ||
        JSON.parse(window.localStorage.getItem("data") || "{}").data,
      insti:
        this.$route.params.insti ||
        JSON.parse(window.localStorage.getItem("insti") || "{}"),
    };
  },
  computed: {
    /**
     * 当前激活菜单
     * @returns {string}
     */
    activeMenu() {
      return this.$route.name || "add";
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: #666666;
  display: block;
  height: 40px;
  line-height: 40px;
  text-align: left;
  padding-left: 30px;
  box-sizing: border-box;
  font-size: 14px;
}
.b_index {
  margin-bottom: 20px;
  background: #fff;
  font-size: 16px;
  text-align: center;
  padding: 0;
  color: #00abfa;
}
.case_wrap {
  box-sizing: border-box;
  padding: 0 80px 40px;
  background: #f6f6f6;
  min-height: calc(100vh - 80px);
}
.nav_box {
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
}
.nav_box .nav-group {
  border: 1px solid #fff;
  background: #f6f6f6;
  padding-left: 20px;
  color: #000332;
  font-size: 16px;
}
.el-aside {
  margin-right: 24px;
  margin-top: 30px;
  background: #f6f6f6;
}
.el-menu {
  background: #f6f6f6;
  border: 0;
}
.el-main {
  background-color: #fff;
  margin-top: 30px;
  color: #333;
  text-align: left;
  padding: 24px;
  border-radius: 4px;
  min-height: 560px;
}
.ha:hover,
.ha.active {
  background: #00abfa;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/set.vue